<div class="">

   <div class="container">

      <div class="row">
         <div class="col-12 nopaddingcls">
            <div class="searchmapbtn">
                  <mat-form-field appearance="outline" class="matsearch">
                     <!-- <mat-label tabindex="0" class="accessibility-plugin-ac">{{'SLOT_SEARCH.SEARCH_LOCATION_FOR_VACCINATION' | translate}}  </mat-label> -->
                     <input tabindex="0" matInput type="text" class="accessibility-plugin-ac" placeholder="{{'SLOT_SEARCH.SEARCH_LOCATION_FOR_VACCINATION' | translate}}" autocomplete="off" id="searchPlace" [(ngModel)]="searchPlace" [placeholder]="'SLOT_SEARCH.SEARCH_NEAREST_LOCATION' | translate" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search>
                        <mat-icon matSuffix  (click)="getPlaces()" class="icon-search_black_24dp-1"></mat-icon>
                  </mat-form-field>
                  <!-- <button  class="searchbtnmap" (click)="getPlaces()"> {{'Search'}}</button> -->
            </div> 
            <p class="nocenter accessibility-plugin-ac" *ngIf="noCenterMsg">{{'SLOT_SEARCH.NO_VACCINATION_CENTER_NEARBY' | translate}}</p>

            <div class="" tabindex="0" style="height: 400px">
               <div id="mapdiv" name="mapdiv" style="height: 400px;"></div>
            </div>
         </div>
      </div>
   </div>
